import { render, staticRenderFns } from "./tabs-head-item.vue?vue&type=template&id=13dd5ac8&scoped=true&"
import script from "./tabs-head-item.vue?vue&type=script&lang=js&"
export * from "./tabs-head-item.vue?vue&type=script&lang=js&"
import style0 from "./tabs-head-item.vue?vue&type=style&index=0&id=13dd5ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd5ac8",
  null
  
)

export default component.exports